module.exports = __webpack_public_path__ + "img/work3.e84ec7df.png";